import IntelModConfig from './intel.mod.list';
export default IntelModConfig;